import axios from "axios";

export type TCenterVerifyOAuthTokenRes = {
  data: {
    userId: number;
    accessToken: string;
    expiresIn: number;
    refreshToken: string;
    email: string;
    organizationId?: number;
    externalId?: string;
  };
};

const centerApi = axios.create({
  baseURL: process.env.REACT_APP_CENTER_API_HOST,
});

export const verifyCenterOAuthToken = async (token: string): Promise<TCenterVerifyOAuthTokenRes["data"]> => {
  const { data } = await centerApi.post<TCenterVerifyOAuthTokenRes>("/admin/oauth/verify-token", { token });
  return data.data;
};

export type TCenterRefreshTokenRes = {
  data: {
    accessToken: string;
    expiresIn: number;
    refreshToken: string;
  };
};

/**
 * Refreshes a handoff (SSO) session.
 *
 * Admin sessions are always minted by irohana-center, so the access/refresh
 * tokens belong to center's Cognito pool. They must be refreshed at center —
 * refreshing them against this account's own Cognito always fails and boots the
 * user back to the center login page. Center re-mints from the access-token
 * claims, so both tokens are sent.
 */
export const refreshCenterOAuthToken = async (accessToken: string, refreshToken: string): Promise<TCenterRefreshTokenRes["data"]> => {
  const { data } = await centerApi.post<TCenterRefreshTokenRes>("/admin/refresh-token", { accessToken, refreshToken });
  return data.data;
};
